import { Link } from 'react-router-dom';
import { CONTACT, FOOTER_LINKS, SITE } from '../../content/site.js';
import logo from '../../assets/logo-lockup.webp';

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-deep pt-16 pb-8">
      <div className="wrap">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <Link to="/" className="mb-4 flex items-center" aria-label={`${SITE.name} home`}>
              <img src={logo} alt="" width="555" height="160" className="h-8 w-auto" />
            </Link>
            <p className="max-w-[280px] text-[13.5px] leading-relaxed text-moss">
              Poultry management with farm sensors that read temperature, humidity and ammonia.
              Track, manage and optimise your flock with continuous monitoring.
            </p>
          </div>

          {FOOTER_LINKS.map((group) => (
            <div key={group.heading}>
              <h2 className="mb-4 font-mono text-[12px] uppercase tracking-[0.15em] text-white">
                {group.heading}
              </h2>
              <ul className="space-y-3">
                {/* <Link> for in-page targets too. A raw anchor reloads the
                    whole app to move down the page; ScrollToTop handles the
                    hash and scrolls smoothly instead. */}
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link to={link.to} className="text-[13.5px] text-moss hover:text-white">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h2 className="mb-4 font-mono text-[12px] uppercase tracking-[0.15em] text-white">
              Contact
            </h2>
            <ul className="space-y-3 text-[13.5px] text-moss">
              <li>{CONTACT.regions}</li>
              {CONTACT.phones.map((p) => (
                <li key={p.e164}>
                  <a href={`tel:+${p.e164}`} className="hover:text-white">
                    {p.display}
                  </a>
                </li>
              ))}
              <li>
                <a href={`mailto:${CONTACT.email}`} className="break-all hover:text-white">
                  {CONTACT.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-wrap items-center justify-between gap-3 border-t border-white/10 pt-6 text-[12.5px] text-dim">
          <span>
            © {year} {SITE.name}. All rights reserved.
          </span>
          <span>Precision poultry management · {CONTACT.regions}</span>
        </div>
      </div>
    </footer>
  );
}
